import React from 'react';
import { Link } from 'react-router-dom';

export const FoundingFooter = () => (
  <footer className="lv2-footer fm-footer" data-testid="founding-footer">
    <div className="lv2-footer-inner fm-footer-inner">
      <div className="lv2-footer-brand">
        <div>SCHEDULES OF WORK · RESIDENTIAL REFURB</div>
        <div className="fm-footer-tagline">Plan, price and define your project before speaking to builders.</div>
        <div className="fm-footer-email" data-testid="footer-email">team@schedulesofwork.com</div>
      </div>
      <nav className="fm-footer-right" aria-label="Footer">
        <div className="lv2-footer-links fm-footer-links">
          <Link to="/terms" data-testid="footer-terms-link">Terms</Link>
          <Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
          <Link to="/unsubscribe" data-testid="footer-unsubscribe-link">Unsubscribe</Link>
          <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
        </div>
        <div className="fm-footer-btns">
          <Link to="/testing" className="fm-outline-btn" data-testid="footer-testing-btn">Testing</Link>
          <Link to="/admin" className="fm-outline-btn" data-testid="footer-admin-btn">Admin</Link>
        </div>
      </nav>
    </div>
  </footer>
);
